export interface ActivityEntry {
  occurred_at: string;
}

export interface ActivityDay {
  key: string;
  label: string;
  count: number;
}

const IST = "Asia/Kolkata";

/** `YYYY-MM-DD` for an instant in Asia/Kolkata. */
export function istDayKey(instant: Date): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: IST,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(instant);
}

/**
 * Last 7 IST days of real track-record events. Days with no events stay
 * at 0 so the bars keep a stable axis. Entries outside the window, or
 * with an unreadable timestamp, are ignored.
 */
export function weekActivity(
  entries: ActivityEntry[],
  now: Date,
  locale: "en" | "hi",
): ActivityDay[] {
  const days: ActivityDay[] = [];
  for (let offset = 6; offset >= 0; offset -= 1) {
    const instant = new Date(now.getTime() - offset * 86_400_000);
    const key = istDayKey(instant);
    days.push({
      key,
      label: new Intl.DateTimeFormat(locale === "hi" ? "hi-IN" : "en-GB", {
        weekday: "short",
        timeZone: IST,
      }).format(instant),
      count: 0,
    });
  }
  const index = new Map(days.map((day, i) => [day.key, i]));
  for (const entry of entries) {
    const parsed = new Date(entry.occurred_at);
    if (Number.isNaN(parsed.getTime())) continue;
    const slot = index.get(istDayKey(parsed));
    if (slot == null) continue;
    const day = days[slot];
    if (day) day.count += 1;
  }
  return days;
}

export function weekActivityTotal(days: ActivityDay[]): number {
  return days.reduce((sum, day) => sum + day.count, 0);
}
